
import { Component, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false
})
export default class InputPassword extends Vue {
  password: string = "";
  type: string = "password";
  switchType() {
    this.type = this.type === "password" ? "text" : "password";
  }
}
